<template>
    <div class="w-full lg:w-[340px] 2xl:w-[465px] relative grid flex-row flex-wrap lg:border-r grid-sidebar " :class="$widgetUI=='NEW-UI' ? 'bgblue100 px-3 py-2 lg:h-[950px]': ' lg:h-[790px]'">
        <div class=" w-full  relative" :class="$widgetUI=='OLD-UI' ? 'bg-primary w-full p-[10px] 2xl:p-[20px] relative':'bgblue100 pt-4'">
            <confirmation-tooltip :visible="confirmationTooltip"/>
            <div v-if="$widgetUI=='OLD-UI'" class="flex content-center flex-row flex-wrap">
                <div class="h1 text-white mb-0 w-full text-[30px] lg:text-[34px] 2xl:text-[38px] text-center">
                    Build <span class="hidden 2xl:inline-block">Your</span> Leads List!
                </div>
                <p class="text-white text-[12px] text-center leading-normal mb-0 w-full">
                    Select "People" to target your audience at home. Select "Businesses"
                    to target people where they work.
                </p>
            </div>

            <div  v-else >

                <div class="hidden lg:flex md:hidden mobile-active mb-3">
                    <button type="button" class="w-full btn btn-tour "  @click="getStartTour()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20" fill="none" class="mx-2">
                            <path d="M10.9242 2.73616L11.2157 2.9759C12.3 3.99198 12.9844 5.36938 13.1344 6.85653C13.2974 8.47137 12.8171 10.0853 11.7979 11.3482C11.0968 12.1794 10.6981 13.2237 10.667 14.3107L10.6668 14.3178V14.325V16.6667C10.6668 17.1971 10.4561 17.7058 10.081 18.0809C9.70592 18.4559 9.19722 18.6667 8.66678 18.6667H5.33345C4.80301 18.6667 4.29431 18.4559 3.91923 18.0809C3.54416 17.7058 3.33345 17.1971 3.33345 16.6667L3.33345 14.1667V14.1589L3.33321 14.1511C3.30219 13.1534 2.92371 12.198 2.2633 11.4497C1.68096 10.7463 1.26051 9.92326 1.03182 9.03906C0.802583 8.15277 0.77165 7.22683 0.941219 6.32722C1.17376 5.12822 1.75711 4.02526 2.6173 3.1582C3.47779 2.29085 4.57653 1.69866 5.77411 1.45675L5.77501 1.45657C6.67442 1.27318 7.60342 1.29289 8.49425 1.51426C9.38507 1.73564 10.2152 2.15309 10.9242 2.73616ZM4.50011 15.3333H4.00011V15.8333L4.00011 16.6667C4.00011 17.0203 4.14059 17.3594 4.39064 17.6095C4.64069 17.8595 4.97983 18 5.33345 18H8.66678C9.0204 18 9.35954 17.8595 9.60959 17.6095C9.85964 17.3594 10.0001 17.0203 10.0001 16.6667V15.8333V15.3333H9.50011L4.50011 15.3333ZM11.274 10.9556L11.2741 10.9556L11.2789 10.9498C12.0747 9.97638 12.5066 8.75608 12.5001 7.49877C12.5003 6.68266 12.3189 5.87672 11.9691 5.1394C11.619 4.40163 11.109 3.75107 10.4762 3.23497C9.84331 2.71886 9.10348 2.35015 8.31037 2.15561C7.51726 1.96106 6.69079 1.94557 5.89095 2.11026L5.89041 2.11037C4.95973 2.30305 4.09487 2.73362 3.38014 3.36008C2.66542 3.98655 2.12523 4.78753 1.81224 5.68494C1.49926 6.58234 1.42417 7.54554 1.59428 8.4806C1.7644 9.41567 2.17392 10.2907 2.78291 11.0204L2.78282 11.0204L2.78993 11.0286C3.5516 11.9021 3.98023 13.0165 4.00019 14.1753L4.00865 14.6667H4.50011L6.16678 14.6667H6.66678L6.66678 14.1667V11.6667C6.66678 11.5782 6.7019 11.4935 6.76441 11.431L6.41086 11.0774L6.76441 11.431C6.82693 11.3684 6.91171 11.3333 7.00011 11.3333C7.08852 11.3333 7.1733 11.3684 7.23582 11.431C7.29833 11.4935 7.33345 11.5782 7.33345 11.6667V14.1667L7.33345 14.6667H7.83345H9.50011H9.97575L9.99949 14.1916C10.0589 13.0026 10.5066 11.8658 11.274 10.9556Z" fill="#3B3B3B" stroke="#3B3B3B"/>
                        </svg>
                        Take a quick tour</button>
                </div>
                <div data-title="Choose Database" data-intro='Start by selecting the database you want to work with.' data-step="1" data-position="right-middle-aligned">
                    <div class="text-black-50  text-[18px] my-4 font-bold pt-2 hidden xl:flex" v-if="$widgetUI=='NEW-UI'">
                        Choose leads list
                        <help-tip
                            content='Select a database to start your search.'
                            class="ml-2"
                        />
                    </div>

                    <audience-static-audience/>
                </div>
            </div>

            <audience-static-audience v-if="$widgetUI=='OLD-UI'"/>
            <div class="text-black-50 text-[18px] mt-2 font-bold py-3 hidden lg:flex" v-if="$widgetUI=='NEW-UI'">
                Choose filters
                <help-tip
                    content='Build a targeted list using the filters below.'
                    class="ml-2"
                />
            </div>
            <div v-if="$widgetUI=='NEW-UI' && checkLocalstorage && desktopTabActive" data-title="Filters on last visit" data-intro="To reload your previous list, simply click 'Apply.'" data-step="2" data-position="bottom-middle-aligned" class="mb-3">
                <div id="accordion-collapse" data-accordion="collapse" class="bg-white py-2 px-4 hidden xl:block" v-if="$widgetUI=='NEW-UI' && checkLocalstorage">
                    <h2 id="accordion-collapse-heading-1" class="mt-1">
                        <button type="button" class="flex items-center justify-between w-full text-[14px]" data-accordion-target="#accordion-collapse-body-1" aria-expanded="true" aria-controls="accordion-collapse-body-1" @click="accordion= !accordion">
                            <span>Filters on your last visit :</span>

                            <svg data-accordion-icon class="w-3 h-3  shrink-0" :class="accordion ? 'rotate-0': 'rotate-180'"  aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                            </svg>

                        </button>
                    </h2>
                    <div id="accordion-collapse-body-1" :class="accordion ? 'block': 'hidden'" aria-labelledby="accordion-collapse-heading-1">
                        <select-from-storage v-if="checkLocalstorage"/>
                    </div>
                </div>
            </div>

        </div>
        <div v-show="desktopTabActive && $widgetUI=='NEW-UI'" class="relative flex-row flex-wrap overflow-y-auto mb-2 hidden lg:grid"
             data-title="Choose Filters" data-intro='Customize your list by applying filters to focus on what matters most.' data-step="3" data-position="right" data-scroll-to="tooltip"
        >
            <div class="tabs w-full" data-tabs :class="$widgetUI=='NEW-UI' ? 'hidden lg:flex': '' ">
                <template v-for="tab in tabs">
                    <div :key="tab.key"
                         class="tab-item"
                         :class="[{'active': activeTab.key === tab.key}, {'complete': tab.index < activeTab.index}]"
                         @click="setTab(tab)">
                        {{ tab.title }}
                    </div>
                </template>
            </div>

            <div class="overflow-y-auto p-2 2xl:p-4 w-full" :class="$widgetUI=='NEW-UI' ? 'hidden lg:block': '' ">

                <contact-info v-show="activeTab.key === 'contact_info'"/>
                <geography v-show="activeTab.key === 'geography'" :with-step="false"/>
                <selections v-show="activeTab.key === 'selections'"/>
            </div>

            <div v-if="$widgetUI=='OLD-UI'" class="w-full h-[50px] border-t border-b lg:border-b-0 sticky bottom-0 bg-white z-10">
                <div
                    class="justify-between items-center flex relative h-full px-2">
                    <template v-if="showBackBtn">
                        <button type="button"
                                class="btn btn-gray bg-fully uppercase disabled:cursor-not-allowed disabled:bg-gray-300 disabled:border-gray-300 btn-arrow-left flex"
                                @click="backTab()">
                            <icon-arrow class="left-4 arrow-btn arrow-mirror"/>
                            Back
                        </button>
                    </template>
                    <template v-else>
                        <div class="uppercase text-[12px]">
                            Next step:
                        </div>
                    </template>

                    <template v-if="showNextBtn">
                        <button type="button"
                                class="group btn btn-orange bg-fully uppercase disabled:cursor-not-allowed disabled:bg-gray-300 disabled:border-gray-300 btn-arrow-right"
                                @click="nextTab()">
                            {{ changeTabButtonText }}

                            <icon-arrow class="right-4 group-hover:text-quaternary arrow-btn"
                                        color="text-white"/>
                        </button>
                    </template>
                    <template v-else>
                        <button type="button" class="group btn btn-orange bg-fully btn-arrow-right flex" @click="focusLead()">
                            CHOOSE QUANTITY
                            <icon-arrow class="right-4 group-hover:text-quaternary arrow-btn"
                                        color="text-white"/>
                        </button>
                    </template>
                </div>
            </div>
        </div>
        <div v-if="$widgetUI=='OLD-UI'" class="relative flex-row flex-wrap overflow-y-auto mb-2" data-title="Choose Filters">
            <div class="tabs w-full" data-tabs :class="$widgetUI=='NEW-UI' ? 'hidden lg:flex': '' ">
                <template v-for="tab in tabs">
                    <div :key="tab.key"
                         class="tab-item"
                         :class="[{'active': activeTab.key === tab.key}, {'complete': tab.index < activeTab.index}]"
                         @click="setTab(tab)">
                        {{ tab.title }}
                    </div>
                </template>
            </div>

            <div class="overflow-y-auto p-2 2xl:p-4 w-full" :class="$widgetUI=='NEW-UI' ? 'hidden lg:block': '' ">

                <contact-info v-show="activeTab.key === 'contact_info'"/>
                <geography v-show="activeTab.key === 'geography'" :with-step="false"/>
                <selections v-show="activeTab.key === 'selections'"/>
            </div>

            <div v-if="$widgetUI=='OLD-UI'" class="w-full h-[50px] border-t border-b lg:border-b-0 sticky bottom-0 bg-white z-10">
                <div
                    class="justify-between items-center flex relative h-full px-2">
                    <template v-if="showBackBtn">
                        <button type="button"
                                class="btn btn-gray bg-fully uppercase disabled:cursor-not-allowed disabled:bg-gray-300 disabled:border-gray-300 btn-arrow-left flex"
                                @click="backTab()">
                            <icon-arrow class="left-4 arrow-btn arrow-mirror"/>
                            Back
                        </button>
                    </template>
                    <template v-else>
                        <div class="uppercase text-[12px]">
                            Next step:
                        </div>
                    </template>

                    <template v-if="showNextBtn">
                        <button type="button"
                                class="group btn btn-orange bg-fully uppercase disabled:cursor-not-allowed disabled:bg-gray-300 disabled:border-gray-300 btn-arrow-right"
                                @click="nextTab()">
                            {{ changeTabButtonText }}

                            <icon-arrow class="right-4 group-hover:text-quaternary arrow-btn"
                                        color="text-white"/>
                        </button>
                    </template>
                    <template v-else>
                        <button type="button" class="group btn btn-orange bg-fully btn-arrow-right flex" @click="focusLead()">
                            CHOOSE QUANTITY
                            <icon-arrow class="right-4 group-hover:text-quaternary arrow-btn"
                                        color="text-white"/>
                        </button>
                    </template>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { EventBus } from "@widget/plugins/event-bus";
import geography from "./geography";
import selections from "./selections";
import confirmationTooltip from "./confirmation-tooltip";
import ContactInfo from "./contact-info";
import AudienceStaticAudience from "./audience-static-audience";
import selectFromStorage from "./select-from-storage";
import dayjs from "dayjs";
import introJS from 'intro.js';

export default {
    name: "sidebar-static-audience",
    components: {
        AudienceStaticAudience,
        ContactInfo,
        geography,
        selections,
        confirmationTooltip,
        selectFromStorage
    },

    computed: {
        divice(){
            return window.innerWidth;
        },
        audience () {
            return this.$store.getters["widgetData/selectedData"].audience;
        },
        changeTabButtonText () {
            return this.tabs[this.activeTab.index].title;
        },
        confirmationTooltip () {
            return this.$store.getters["others/getConfirmationTooltip"];
        },
        tabs () {
            let textStepSelection = this.$store.getters["widgetData/selectedData"].audience === this.$widgetConfig.b2cBase ? "Demographics" : "Firmographics";

            /* if (this.$widgetConfig.contactInfo3rd) {
                 return [
                     {
                         index: 1,
                         title: "Geography",
                         key: "geography"
                     },
                     {
                         index: 2,
                         title: textStepSelection,
                         key: "selections"
                     },
                     {
                         index: 3,
                         title: "Contact Info",
                         key: "contact_info"
                     }
                 ];
             }*/

            return [

                {
                    index: 1,
                    title: "Geography",
                    key: "geography"
                },
                {
                    index: 2,
                    title: textStepSelection,
                    key: "selections"
                },
                {
                    index: 3,
                    title: "Contact Info",
                    key: "contact_info"
                }
            ];
        },
        showBackBtn () {
            return this.activeTab.index > 1;
        },
        showNextBtn () {
            return this.activeTab.index < 3;
        },
        checkLocalstorage () {
            let storage = JSON.parse(localStorage.getItem("widget-store"));
            if (storage) {
                let a = dayjs(storage.expireDate);
                let b = dayjs(Date.now());
                if (a.diff(b, "days") < 10) {
                    return true;
                } else {
                    localStorage.removeItem("widget-store");
                    return false;
                }
            }
            return false;
        }
    },
    watch: {
        audience () {
            this.activeTab = this.tabs[0];
        }
    },
    methods: {
        focusLead () {
            this.$scrollTo("body", 500, { offset: 0 });
            EventBus.$emit("focus-input-lead");
        },
        setTab (payload) {
            this.activeTab = payload;
        },
        nextTab () {
            let currentIndex = this.tabs.findIndex(item => item.key === this.activeTab.key);
            if (currentIndex !== -1) {
                this.activeTab = this.tabs[currentIndex + 1];
            }
        },
        getStartTour(){
            console.log('introJS', introJS().start())
            introJS().setOptions({
                showStepNumbers: true,
                stepNumbersOfLabel: true,
                showBullets:false
            }).start();
        },
        backTab () {
            let currentIndex = this.tabs.findIndex(item => item.key === this.activeTab.key);
            if (currentIndex !== -1) {
                this.activeTab = this.tabs[currentIndex - 1];
            }
        },
        getcheckDivec(){
            this.innerWidth = window.innerWidth;
            if(this.innerWidth  < 1024 && this.innerWidth  > 724 ){
                this.tabletActive=true;
                this.mobileTabActive=false;
                this.desktopTabActive=false;
            }
            else if (this.innerWidth < 724){
                this.tabletActive=false;
                this.mobileTabActive=true;
                this.desktopTabActive=false;
            }
            else{
                this.tabletActive=false;
                this.mobileTabActive=false;
                this.desktopTabActive=true;
            }
        }
    },
    data () {
        return {
            activeTab: null  ,
            accordion: true,
            innerWidth: window.innerWidth,
            tabletActive:false,
            mobileTabActive:false,
            desktopTabActive:true,

        };
    },
    created () {
        let treatment = this.$store.getters["others/getTreatment"]("toggle_firmographics");
        this.activeTab = treatment && treatment === "on" ? this.tabs.find(item => item.key === "selections") : this.tabs[0];
    },
    mounted () {
        this.getcheckDivec();
        EventBus.$on("edit-select", () => {
            this.activeTab = this.tabs.find(item => item.key === "selections");
        });

        EventBus.$on("show-select-position", (select) => {
            if (select.code) {
                let geoTab = select.code.includes("_geo_search") || select.code.includes("_zip_radius") || select.code.includes("_mapping");

                if (geoTab) {
                    this.activeTab = this.tabs.find(item => item.key === "geography");
                } else if (select.code.includes("_one_per_address")) {
                    this.activeTab = this.tabs.find(item => item.key === "contact_info");
                } else {
                    this.activeTab = this.tabs.find(item => item.key === "selections");
                }
            } else if (select === "sub-audience") {
                this.activeTab = this.tabs.find(item => item.key === "contact_info");
            } else if (select === "geography") {
                this.activeTab = this.tabs.find(item => item.key === "geography");
            }
        });
        window.addEventListener('resize', () => {
            this.getcheckDivec();
        })
    }
};
</script>

<style lang="scss" scoped>
.mobileview{
    display:none;
}
.bg-primary-100{
    background: #EDF3FF;
    padding: 15px 8px;
}
.gap-16{
    gap:18px
}
.btn-tour{
    background: #FBEBD4;
    border-radius: 6px;
    display:flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #B1B1B1;
    font-size:16px;

}
</style>
